export const listPermission = [
  'USER_MANAGEMENT',
  'ROLE_AND_PERMISSION',
  'TEAMS',
  'SALES_DASHBOARD',
  'UPD_DASHBOARD',
  'LEADS',
  'DEALS',
];
